module.exports = __webpack_public_path__ + "static/media/delete.05e28452.svg";